import Image from "next/image"
import { BASE_PATH } from "@/constants/app.mjs"

const logoList = [
  "logo-ethereum.svg",
  "logo-arbitrum.svg",
  "logo-immutable.svg",
  "logo-optimism.svg",
  "logo-ronin.svg",
  "logo-icp.svg",
  "logo-aptos.svg",
  "logo-ton.svg",
  "logo-avalanche.svg",
  "logo-base.svg",
  "logo-starknet.svg",
  "logo-celo.svg",
  "logo-bnbchain.svg",
  "logo-tron.svg",
  "logo-polkadot.svg",
]

const ChainPartnerGrid = () => {
  const logos = logoList.slice(0, 15)

  return (
    <div
      className="flex flex-col gap-2 items-center py-16 animate-fade-in-up"
      style={{
        opacity: 0,
        animationDelay: "0.5s",
      }}
    >
      <div className="text-fg-secondary text-center px-10x mb-4x lg:mb-6x">
        We already run data pipelines for the leading chains.
      </div>
      <div className="w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 items-center justify-center justify-items-center invert dark:invert-0">
        {logos.map((logo) => (
          <Image
            key={logo}
            className="w-full h-[120px] grid-cols-1 last-of-type:col-span-full md:last-of-type:col-span-1"
            alt={logo}
            src={`${BASE_PATH}/static/images/marketing/app-partnership/logos/${logo}`}
            width={520}
            height={500}
          />
        ))}
      </div>
    </div>
  )
}

export default ChainPartnerGrid
